/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { LoginRequestToJSON, PasswordChangeDTOToJSON, RegisterRequestToJSON, } from '../models/index';
/**
 *
 */
export class AuthControllerApi extends runtime.BaseAPI {
    /**
     */
    async authenticateUserRaw(requestParameters, initOverrides) {
        if (requestParameters['loginRequest'] == null) {
            throw new runtime.RequiredError('loginRequest', 'Required parameter "loginRequest" was null or undefined when calling authenticateUser().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/auth/login`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginRequestToJSON(requestParameters['loginRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async authenticateUser(requestParameters, initOverrides) {
        const response = await this.authenticateUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async changePasswordRaw(requestParameters, initOverrides) {
        if (requestParameters['passwordChangeDTO'] == null) {
            throw new runtime.RequiredError('passwordChangeDTO', 'Required parameter "passwordChangeDTO" was null or undefined when calling changePassword().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/auth/change-password`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PasswordChangeDTOToJSON(requestParameters['passwordChangeDTO']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async changePassword(requestParameters, initOverrides) {
        await this.changePasswordRaw(requestParameters, initOverrides);
    }
    /**
     */
    async registerUserRaw(requestParameters, initOverrides) {
        if (requestParameters['registerRequest'] == null) {
            throw new runtime.RequiredError('registerRequest', 'Required parameter "registerRequest" was null or undefined when calling registerUser().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/auth/register`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegisterRequestToJSON(requestParameters['registerRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async registerUser(requestParameters, initOverrides) {
        const response = await this.registerUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
